import request from '../axios';

/**
 * 内容相关API接口
 */
const contentAPI = {
  /**
   * 获取内容列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.pageSize - 每页数量
   * @returns {Promise} - 返回Promise对象
   */
  getContents(params) {
    return request({
      url: '/contents',
      method: 'GET',
      params
    });
  },

  /**
   * 根据ID获取内容详情
   * @param {number} content_id - 内容ID
   * @returns {Promise} - 返回Promise对象
   */
  getContentById(content_id) {
    return request({
      url: `/contents/${content_id}`,
      method: 'GET'
    });
  },

  /**
   * 根据contentId获取内容
   * @param {string} contentId - 内容标识
   * @returns {Promise} - 返回Promise对象
   */
  getContentByContentId(contentId) {
    return request({
      url: `/contents/content-id/${contentId}`,
      method: 'GET'
    });
  },

  /**
   * 添加新内容
   * @param {Object} data - 内容数据
   * @param {string} data.contentId - 内容标识
   * @param {string} data.contentText - 内容文本
   * @returns {Promise} - 返回Promise对象
   */
  addContent(data) {
    return request({
      url: '/contents',
      method: 'POST',
      data
    });
  },

  /**
   * 更新内容
   * @param {number} content_id - 内容ID
   * @param {Object} data - 更新数据
   * @returns {Promise} - 返回Promise对象
   */
  updateContent(data) {
    return request({
      url: `/contents/update`,
      method: 'POST',
      data
    });
  },

  /**
   * 删除内容
   * @param {number} content_id - 内容ID
   * @returns {Promise} - 返回Promise对象
   */
  deleteContent(content_id) {
    return request({
      url: `/contents/${content_id}`,
      method: 'DELETE'
    });
  },

  /**
   * 根据模板ID获取内容列表
   * @param {number} template_id - 模板ID
   * @returns {Promise} - 返回Promise对象
   */
  getContentsByTemplate(template_id) {
    return request({
      url: `/contents/template/${template_id}`,
      method: 'GET'
    });
  },

  /**
   * 根据模板ID获取内容列表
   * @param {number} template_id - 模板ID
   * @returns {Promise} - 返回Promise对象
   */
  deleteContentsBatch(data) {
    return request({
      url: `/contents/batch`,
      method: 'DELETE',
      data
    });
  }

};



export default contentAPI;